import "aos/dist/aos.css";
import React from "react";

export default function Alert( {type, children, className, ...rest} ){
    return (
      <>
        {children!==null && <section>
          <div className={`alert alert-${type} ${className}`} {...rest} role="alert">
            { children }
          </div>
        </section>}
      </>
    );
}
